import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function AdminLogin({ onClose, onSuccess }) {
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    async function submit(event) {
        event.preventDefault();
        setBusy(true);
        setError('');
        try {
            await login(email.trim(), password);
            onSuccess?.();
            onClose();
        } catch (err) {
            setError(err.message || 'Unable to sign in.');
        } finally {
            setBusy(false);
        }
    }
    return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
        <section role="dialog" aria-modal="true" aria-labelledby="admin-login-title" className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <div className="flex justify-between mb-5"><h2 id="admin-login-title" className="text-xl font-semibold">Admin sign in</h2>
                <button type="button" onClick={onClose} aria-label="Close sign in">Close</button></div>
            <form onSubmit={submit} className="space-y-4">
                <label className="block">Email<input className="block w-full border rounded p-2" type="email" autoComplete="username" required value={email} onChange={e => setEmail(e.target.value)} /></label>
                <label className="block">Password<input className="block w-full border rounded p-2" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} /></label>
                {error && <p role="alert" className="text-red-700">{error}</p>}
                <button disabled={busy} className="w-full rounded bg-purple-700 p-3 text-white disabled:opacity-50">{busy ? 'Signing in…' : 'Sign in'}</button>
            </form>
        </section>
    </div>;
}
